import { render, staticRenderFns } from "./DashboardShipperNew.vue?vue&type=template&id=205a1937"
import script from "./DashboardShipperNew.vue?vue&type=script&lang=js"
export * from "./DashboardShipperNew.vue?vue&type=script&lang=js"
import style0 from "./DashboardShipperNew.vue?vue&type=style&index=0&id=205a1937&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports